import gsap from 'gsap';
import { Action } from './Action.class';

/** GSAP 音频轨道：播放、越界停止和局部时间同步都只在这里发生。 */
export class PlayAction extends Action {
  protected _playing = false;
  protected playTween: gsap.core.Tween | null = null;

  protected override doRefreshMotion(): void {
    super.doRefreshMotion();
    this.initPlayTween();
  }

  protected initPlayTween(): void {
    this.destroyPlayTween();
    if (!this._element) return;

    this.playTween = gsap.fromTo(
      this.time,
      { n: 0 },
      {
        n: 1,
        duration: this.duration,
        immediateRender: false,
        ease: 'none',
        onUpdate: this.handleTimelineUpdate,
        onComplete: this.handleTimelineExit,
        onReverseComplete: this.handleTimelineExit
      }
    );

    this._tween?.add(this.playTween, 0);
  }

  /** 轨道内只转发 GSAP 局部时间；是否需要起播完全由 Element.seekPlay() 判断。 */
  private readonly handleTimelineUpdate = () => {
    if (this._playing) {
      this._element?.seekPlay(this.time.n * this.duration);
    } else {
      this._element?.seek(this.time.n * this.duration);
    }
  };

  /** 正向或反向离开 [startTime, startTime + duration) 都必须停止。 */
  private readonly handleTimelineExit = () => {
    this._playing = false;
    this.stopElement();
  };

  public play(): void {
    this._playing = true;
  }

  public pause(): void {
    this._playing = false;
    this._element?.pause();
  }

  /** seek 前清空旧轨道状态，禁止 render 目标位置时意外起播。 */
  public stopForSeek(): void {
    this._playing = false;
    this.stopElement();
  }

  private stopElement(): void {
    this._element?.stop();
  }

  public destroyPlayTween(): void {
    this.playTween?.kill();
    this.playTween = null;
  }

  public override destroy(): void {
    this.stopElement();
    this.destroyPlayTween();
    super.destroy();
  }

  public get playing(): boolean {
    return this._playing;
  }
}
